import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { id: "today", label: "今日瓜" },
  { id: "scene", label: "现场直击" },
  { id: "trend", label: "热点话题" },
  { id: "about", label: "关于瓜场" },
  { id: "faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav
        className="mx-auto flex h-16 md:h-[68px] max-w-[1200px] items-center justify-between px-4 md:px-6"
        aria-label="主导航"
      >
        {/* logo */}
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg font-bold">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-bold text-lg tracking-tight ${solid ? "text-foreground-950" : "text-white"}`}>
              瓜场
            </span>
            <span className={`text-[10px] tracking-widest mt-0.5 ${solid ? "text-foreground-600" : "text-white/80"}`}>
              今日瓜 · 现场快讯
            </span>
          </span>
        </a>

        {/* desktop links */}
        <div className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((it) => (
            <a
              key={it.id}
              href={`#${it.id}`}
              className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                solid
                  ? "text-foreground-800 hover:bg-background-100 hover:text-primary-600"
                  : "text-white/90 hover:bg-white/15 hover:text-white"
              }`}
            >
              {it.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#today"
            className={`hidden sm:inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-white text-primary-600 hover:bg-primary-50"
            }`}
          >
            <i className="ri-fire-fill text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            看热榜
          </a>
          {/* mobile hamburger */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-full transition-colors cursor-pointer ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/15"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </nav>

      {/* mobile menu */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col">
            {NAV_ITEMS.map((it) => (
              <a
                key={it.id}
                href={`#${it.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-foreground-900 hover:bg-background-100"
              >
                {it.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}